import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../_models/configuration';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private configData = new BehaviorSubject<Configuration>(new Configuration);
  configData$ = this.configData.asObservable();

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private originUrl: string
  ) { }

  loadConfigurationData() {
    return new Promise<void>((resolve, reject) => {
      /* TODO: Disable this for all check-ins */
      //let data: Configuration = new Configuration;
      ////data.apiAddress = 'https://runtix.azurewebsites.net/';
      //data.apiAddress = 'http://localhost:64779/';
      //data.reportViewerAddress = 'http://localhost:65255/';
      //data.webAppAddress = 'Deprecated';
      //data.showDashboards = true;
      //data.showCreateActBtn = true;
      //data.tokenExpireInSec = 86400;
      //data.companyLogos = [{
      //"Name":"allegiant","DisplayName":"Allegiant","HasLogo":true},{"Name":"frostwood","DisplayName":"Allegiant","HasLogo":true},{"Name":"jacuzzi","DisplayName":"Jacuzzi","HasLogo":true},{"Name":"northsouth","DisplayName":"North South Oil","HasLogo":true},{"Name":"pintail","DisplayName":"Pintail Oil & Gas","HasLogo":false},{"Name":"saolc","DisplayName":"Sue-Ann Operating","HasLogo":true},{"Name":"shoreline","DisplayName":"Marquis Resources","HasLogo":false},{"Name":"sme","DisplayName":"Square Mile Energy","HasLogo":true},{"Name":"svec","DisplayName":"SV Energy Company","HasLogo":true},{"Name":"torrent","DisplayName":"Torrent Oil","HasLogo":true},{"Name":"tpic","DisplayName":"Texas Petroleum Investment Co.","HasLogo":true},{"Name":"tri-c","DisplayName":"Tri-C Resources","HasLogo":true},{"Name":"wesco","DisplayName":"Wesco","HasLogo":false},{"Name":"wkp","DisplayName":"White Knight Production","HasLogo":true},{"Name":"zachry","DisplayName":"Zachry","HasLogo":true}];
      //data.version = '2.0.0';
      //this.configData.next(data);
      //resolve();

      /* TODO: Enable this for all check-ins */
      this.http.get(this.originUrl + 'api/Configuration').subscribe({
        next: (data: Configuration) => {
          this.configData.next(data);
          resolve();
        },
        error: err => {
          console.warn('APP INITIALIZER REJECTED');
          reject();
        }
      });
    })
  }

  get config(): Configuration {
    return this.configData.getValue();
  }
}
